import { LOGIN_TO_ISBYB_FULFILLED, LOG_OUT, SET_KEYCLOAK, SET_KEYCLOAK_USER } from '../constants/ActionTypes'

const initialState = {
  token: null,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_TO_ISBYB_FULFILLED: {
      state = {
        ...state,
        token: action.payload.token,
      }
      break
    }

    case SET_KEYCLOAK_USER: {
      state = {
        ...state,
        ...action.payload,
      }
      break
    }

    case SET_KEYCLOAK: {
      state = {
        ...state,
        keycloak: action.payload,
      }
      break
    }

    case LOG_OUT: {
      if (state.keycloak) {
        state.keycloak.logout()
      }
      break
    }

    default:
      break
  }
  return state
}

export default userReducer
